import { dew as _constantsDew } from "../constants";
import { dew as _resultsDew } from "../../../results";
import { dew as _AbstractParserWithWordBoundaryDew } from "../../../common/parsers/AbstractParserWithWordBoundary";
import { dew as _timeunitsDew } from "../../../utils/timeunits";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  const constants_1 = _constantsDew();
  const results_1 = _resultsDew();
  const AbstractParserWithWordBoundary_1 = _AbstractParserWithWordBoundaryDew();
  const timeunits_1 = _timeunitsDew();
  const PATTERN = new RegExp(`(${constants_1.TIME_UNITS_PATTERN})\\s{0,5}назад(?=(?:\\W|$))`, constants_1.REGEX_PARTS.flags);
  class RUTimeUnitAgoFormatParser extends AbstractParserWithWordBoundary_1.AbstractParserWithWordBoundaryChecking {
    patternLeftBoundary() {
      return constants_1.REGEX_PARTS.leftBoundary;
    }
    innerPattern() {
      return PATTERN;
    }
    innerExtract(context, match) {
      const timeUnits = constants_1.parseTimeUnits(match[1]);
      const outputTimeUnits = timeunits_1.reverseTimeUnits(timeUnits);
      return results_1.ParsingComponents.createRelativeFromReference(context.reference, outputTimeUnits);
    }
  }
  exports.default = RUTimeUnitAgoFormatParser;
  //# sourceMappingURL=RUTimeUnitAgoFormatParser.js.map
  return exports;
}